import api from "@/lib/api";

export const DOC_ICONS = { dc: "FileText", courier_label: "Truck", tip_label: "Lightbulb", welcome_label: "Sparkles", packing_list: "Package", serial_report: "ListChecks", dispatch_summary: "ClipboardList" };

export async function errText(e) {
  const d = e?.response?.data;
  if (d instanceof Blob) {
    try { const j = JSON.parse(await d.text()); return fmt(j.detail); } catch { return e.message; }
  }
  return fmt(d?.detail) || e.message;
}

function fmt(detail) {
  if (!detail) return "";
  if (typeof detail === "string") return detail;
  if (detail.message) return `${detail.message}${detail.blocked?.length ? ` — ${detail.blocked.slice(0, 3).join(" · ")}` : ""}`;
  return JSON.stringify(detail);
}

export async function fetchDoc(orderId, type, ids, mode) {
  const q = new URLSearchParams({ mode });
  if (ids?.length) q.set("dc_ids", ids.join(","));
  const r = await api.get(`/document-centre/orders/${orderId}/render/${type}?${q}`, { responseType: "blob" });
  const cd = r.headers["content-disposition"] || "";
  const name = (cd.match(/filename="([^"]+)"/) || [])[1] || `${type}.pdf`;
  return { url: URL.createObjectURL(new Blob([r.data], { type: "application/pdf" })), name, count: r.headers["x-doc-count"] };
}

export function saveAs(url, name) {
  const a = document.createElement("a");
  a.href = url; a.download = name; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}

export function printUrl(url) {
  const f = document.createElement("iframe");
  f.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0";
  f.src = url;
  f.onload = () => { try { f.contentWindow.focus(); f.contentWindow.print(); } catch { window.open(url, "_blank"); } setTimeout(() => f.remove(), 60000); };
  document.body.appendChild(f);
}
